<script>
    let className = '';
    export { className as class };
    export let sm = false;
    export let lg = false;
    export let xl = false;
    export let invert = false;
    export let tag = 'h1';
</script>

<svelte:element
    this={tag}
    class="font-extrabold leading-none text-balance
    {xl
        ? 'text-[2.4rem] md:text-[4rem]'
        : sm
        ? 'text-[1.875rem] leading-[1.2] md:text-[3rem] md:leading-none'
        : lg
        ? 'text-5xl md:text-6xl'
        : 'text-4xl md:text-5xl'}
    {invert ? 'text-symbols-invert-highlight' : 'text-symbols-highlight'}
    {className}"
>
    <slot />
</svelte:element>
